/**
 * Sticky add to cart + Kaching Bundles.
 *
 * La barra sticky del tema ha un <form> prodotto tutto suo, separato da quello
 * del buy box. Kaching applica il bundle scrivendo nel form PRINCIPALE due cose:
 *
 *   properties[__kaching_bundles]  la deal scelta, su cui il server calcola lo sconto
 *   quantity                       i pezzi del bundle
 *
 * Il form della sticky non le vede, quindi aggiunge sempre 1 pezzo.
 *
 * Copiare i campi da un form all'altro non basta e sarebbe rischioso: Kaching
 * puo' selezionare varianti diverse per i pezzi del bundle e in quel caso non
 * fa un semplice POST. Qui invece il click sulla sticky viene reindirizzato sul
 * pulsante del form principale, cosi' passa esattamente quello che Kaching ha
 * preparato, sconto compreso.
 *
 * Se il form principale non c'e' o il suo pulsante non e' disponibile, la
 * sticky torna a comportarsi come prima.
 */
(function () {
  const SEL_STICKY_FORM = '.sticky-atc-bar__form';
  const SEL_MAIN_FORM = 'form.main-product-form';
  const SEL_ADD = '[name="add"]';

  function formPrincipale(stickyForm) {
    const main = document.querySelector(SEL_MAIN_FORM);
    if (!main) return null;

    // Deve trattarsi dello stesso prodotto: la sticky puo' comparire altrove.
    const idSticky = stickyForm.querySelector('[name="product-id"]');
    const idMain = main.querySelector('[name="product-id"]');
    if (idSticky && idMain && idSticky.value !== idMain.value) return null;

    return main;
  }

  function varianteDi(form) {
    const campo = form.querySelector('[name="id"]');
    return campo ? String(campo.value || '') : '';
  }

  function stessaVariante(stickyForm, main) {
    const a = varianteDi(stickyForm);
    const b = varianteDi(main);
    if (!a || !b) return true; // niente selettore: non c'e' divergenza possibile
    return a === b;
  }

  function haBundle(main) {
    return (
      main.className.indexOf('kaching-bundles-form') !== -1 ||
      !!main.querySelector('[name^="properties[__kaching_bundles]"]')
    );
  }

  // Capture: deve precedere il gestore del custom element <product-form>.
  document.addEventListener(
    'click',
    function (e) {
      const bottone = e.target.closest ? e.target.closest(SEL_ADD) : null;
      if (!bottone) return;

      const sticky = bottone.closest(SEL_STICKY_FORM);
      if (!sticky) return;

      const main = formPrincipale(sticky);
      if (!main) return;

      // Si delega solo dove serve, cioe' dove c'e' un bundle da trasportare.
      // Senza bundle il form della sticky e' gia' corretto da solo, e dirottarlo
      // farebbe ignorare la variante scelta nella barra.
      if (!haBundle(main)) return;

      // Con piu' varianti la barra ha un suo select: se punta a una variante
      // diversa da quella del buy box, delegare aggiungerebbe il prodotto
      // sbagliato. Meglio lasciar fare al tema.
      if (!stessaVariante(sticky, main)) return;

      const bottoneMain = main.querySelector(SEL_ADD);
      if (!bottoneMain || bottoneMain.disabled) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      bottoneMain.click();
    },
    true
  );

  /**
   * Con un bundle attivo la quantita' la decide il selettore del bundle: quella
   * della sticky non avrebbe effetto, e lasciarla visibile farebbe credere il
   * contrario. Senza bundle resta dov'era.
   */
  function allineaQuantita() {
    const sticky = document.querySelector(SEL_STICKY_FORM);
    if (!sticky) return;

    const main = formPrincipale(sticky);
    if (!main || !haBundle(main)) return;

    const qty = sticky.querySelector('.quantity');
    if (qty) qty.hidden = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', allineaQuantita);
  } else {
    allineaQuantita();
  }
  // Kaching monta dopo: si ricontrolla a pagina caricata.
  window.addEventListener('load', allineaQuantita);
})();
